import React from "react";
import { TabbedShowLayout, Tab } from "react-admin";
import { Box, Paper } from "@material-ui/core";
import { Route, Redirect } from "react-router-dom";
import { FeaturedClassesList } from "./components/FeaturedClassesList";
import { FeaturedPlaylistsList } from "./components/FeaturedPlaylistsList";

export function FeaturedList(): JSX.Element {
  return (
    <Paper>
      <Route exact path="/featured">
        <Redirect to="/featured/classes" />
      </Route>
      <TabbedShowLayout syncWithLocation>
        <Tab label="Featured Classes" value="classes" path="classes">
          <Box p={2}>
            <FeaturedClassesList />
          </Box>
        </Tab>
        <Tab label="Featured Playlists" value="playlists" path="playlists">
          <Box p={2}>
            <FeaturedPlaylistsList />
          </Box>
        </Tab>
      </TabbedShowLayout>
    </Paper>
  );
}
